import {default as TooltipInteraction} from '@/components/maps/ol/interaction/Tooltip';
import CommonFeaturesMixin from './CommonFeaturesMixin';
import SelectInteraction from '../interaction/SelectInteraction';
import { EVENTS } from '../config/event-constants';
// import {bbox as bboxStrategy} from 'ol/loadingstrategy';
import GeoJSON from 'ol/format/GeoJSON';
import { toCamelCase, formatUrl, isArray, dotNotation, isFunction } from '@config/utils'

let vars = {
    map: null,
    featureStyles: {},
    interactions: {},
    flashListenerKey: null,
};

export default {
    mixins: [
        CommonFeaturesMixin,
    ],
    data() {
        return {
            propertyFlashListenerKey: 'flashListenerKey',
            layers: [
                {
                    key: 'cemeteries',
                    events: {
                        show: EVENTS.SHOW_MODAL_READ_CEMETERY,
                        close: EVENTS.CLOSE_MODAL_READ_CEMETERY,
                        closed: EVENTS.CLOSED_MODAL_READ_CEMETERY,
                    }
                },
                {
                    key: 'sectors',
                    events: {
                        show: EVENTS.SHOW_MODAL_DETAIL_SECTOR,
                        close: EVENTS.CLOSE_MODAL_DETAIL_SECTOR,
                        closed: EVENTS.CLOSED_MODAL_DETAIL_SECTOR,
                    }
                },
                {
                    key: 'occupations',
                    events: {
                        show: EVENTS.SHOW_MODAL_READ_OCCUPATION,
                        close: EVENTS.CLOSE_MODAL_READ_OCCUPATION,
                        closed: EVENTS.CLOSED_MODAL_READ_OCCUPATION,
                    }
                }
            ],
        }
    },
    computed: {
        configMap() {
            return this.moduleCode ? this.$store.getters[`${this.moduleCode}/getConfigMap`] : {};
        },
        clusterCemeteriesProperties() {
            return this.configMap.layers.cluster || {};
        },
        actionMap() {
            return this.moduleCode ? this.$store.getters[`${this.moduleCode}/getActionMap`] : null;
        },
        tooltipConfig() {
            return this.tool ? this.tool.tooltip || {} : null;
        },
        tooltipEnabled() {
            return this.tooltipConfig ? !!this.tooltipConfig.active : false;
        },
        tooltipTemplate() {
            return this.tooltipConfig ? this.tooltipConfig.template : '';
        },
        tooltipId() {
            return `${this.moduleCode}-tooltip-map`;
        },
        tooltipClassName() {
            return 'map-tooltip';
        },
    },
    created() {
        this.$eventBus.listen(this.moduleCode, `map.initialized-${this.mapId}`, this.onMapInitialized);
        this.$eventBus.listen(this.moduleCode, EVENTS.SELECT_FEATURE_CEMETERY, this.onSelectFeature);
    },
    beforeDestroy() {
        this.$eventBus.remove(this.moduleCode, `map.initialized-${this.mapId}`, this.onMapInitialized);
        this.$eventBus.remove(this.moduleCode, EVENTS.SELECT_FEATURE_CEMETERY, this.onSelectFeature);
        this.removeAllMapInteractions();
    },
    methods: {
        onMapInitialized(params) {
            const _map = params.map;
            if(!_map){
                return;
            }
            vars.map = _map;

            this.layers.forEach(layer => {
                this.createLayer(layer.key, layer.events, _map);
            });
        },
        createLayer(key, events, map) {
            let url = this.url[`${toCamelCase(key)}Features`] ?? null;
            if(url){
                url = this.getFormatUrlAPI(url);
                let _map = map;
                const _layerConfig = this.layerProperties(key);
                const optionsCluster = this.clusterCemeteriesProperties;
                const _styleConfig = this.styleProperties(key);

                let sourceId = _layerConfig.source;
                let layerId = _layerConfig.layer;
                let clusterId = _layerConfig.cluster;
                let isCluster = !!clusterId;
                let _source = _map.getSource(sourceId);
                let _layer = _map.getLayer(layerId);
                isCluster = false;
                if(!_source){
                    let _sourceConfig = {
                        useSpatialIndex: true,
                        format: new GeoJSON({
                            dataProjection: map.getProjection().getCode()
                        }),
                        url: (extent, resolution, projection) => {
                            return formatUrl(url, {
                                bbox: extent.join(','),
                                projection: projection.getCode()
                            });
                        },
                        // new ol.source.GeoJSON({
                        //     projection: 'EPSG:3857',
                        //     url: "./data/WELLS.geojson"
                        // }),
                    };
                    if(_layerConfig.bboxStrategy) {
                        _sourceConfig = {
                            ..._sourceConfig,
                            ...{
                                // strategy: bboxStrategy,
                            }
                        };
                    }

                    _source = _map.createVectorSource(_sourceConfig);
                    _map.setSource(sourceId, _source);
                }else{
                    _map.clearSource(sourceId, true);
                }

                let _cluster = null;
                if(isCluster) {
                    _cluster = _map.getLayer(clusterId);
                    if(!_cluster){
                        _cluster = _map.createCluster({
                            source: _source,
                            distance: isCluster ? optionsCluster.distance : 0,
                        });
                        _map.setLayer(clusterId, _cluster);
                    }
                }

                if(!_layer){
                    let style = this.getStyle(key);
                    let iconCluster = isCluster ? _map.createIcon({
                        src: _styleConfig?.cluster?.src,
                        scale: optionsCluster.scale,
                        zIndex: optionsCluster.zindex,
                    }) : null;

                    _layer = _map.createVectorLayer({
                        source: isCluster ? _cluster : _source,
                        style: style,
                        minZoom: _layerConfig.minZoom,
                        maxZoom: _layerConfig.maxZoom,
                        minResolution: _layerConfig.minResolution,
                        maxResolution: _layerConfig.maxResolution,
                        zIndex: isCluster ? optionsCluster.zindex : _layerConfig.zindex,
                        cluster: isCluster,
                        clusterIcon: iconCluster,
                        declutter: _layerConfig.declutter ?? false, // [TODO] ver porque o click no cluster não funciona com o declutter = true
                    }, true);

                    _layer.setProperties({'isCluster': isCluster});
                    _map.setLayer(layerId, _layer);
                    _map.addlayerToMap({layer: _layer});

                    if(_layerConfig?.interactions) {
                        let interactions = _layerConfig.interactions;
                        if(!isArray(interactions)) {
                            interactions = [interactions];
                        }
                        interactions.forEach(interaction => this.addMapInteraction(key, events, interaction, _map, _layer));
                    }
                }
                return true;
            }else{
                return false;
            }
        },
        addMapInteraction(layerKey, layerEvents, key, map, layers) {
            if(vars.interactions[layerKey]  === undefined) {
                vars.interactions[layerKey] = {};
            }
            let interaction = vars.interactions[layerKey][key];
            if(!interaction){
                let _layers = isArray(layers) ? layers: [layers];

                switch (key) {
                    case 'select':
                        let selectInteraction = new SelectInteraction({
                            layers: _layers,
                            hitTolerance: this.selectConfig.hitTolerance ?? 0,
                            zoomToFeature: this.selectConfig.zoom,
                        });

                        selectInteraction.on('select:feature', (evt) => {
                            if(this.actionMap){
                                return true;
                            }

                            let feature = evt.feature;

                            if(layerEvents.show) {
                                this.$eventBus.publish(
                                    this.moduleCode,
                                    layerEvents.show,
                                    {
                                        data: feature.getProperties(),
                                        feature,
                                        event: evt
                                    }
                                );
                            }
                        });

                        selectInteraction.on('deselect:feature', (evt) => {
                            if(this.actionMap){
                                return true;
                            }

                            let feature = evt.feature;
                            let target = evt.target;
                            let layer = target.getLayer(feature);
                            let map = target.getMap();
                            this.onDeSelectFeature({
                                map,
                                layer,
                                feature,
                            })

                            if(evt.mapBrowserEvent && layerEvents.close) {
                                this.$eventBus.publish(this.moduleCode, layerEvents.close, {});
                            }
                        });

                        if(layerEvents.closed) {
                            this.$eventBus.listen(this.moduleCode, layerEvents.closed, (params) => {
                                const {key, data, feature} = params;
                                if(feature) {
                                    selectInteraction.unselect(feature);
                                }else{
                                    this.onDeSelectFeature();
                                }
                            });
                        }

                        interaction = selectInteraction;

                        break;
                    case 'tooltip':
                        let parent = map.getOLMap().getViewport().parentElement;
                        let element = document.getElementById(this.tooltipId);
                        if(!element){
                            element = document.createElement('div');
                            element.setAttribute('id', this.tooltipId);
                            element.setAttribute('class', this.tooltipClassName);
                            parent.appendChild(element);
                        }
                        interaction = new TooltipInteraction({
                            layers: _layers,
                            targetOverlay: element,
                            templateTooltip: this.tooltipTemplate,
                        });
                        interaction.setActive(true);
                        break;
                    default:
                        break;
                }
                map.addInteraction(interaction);
                vars.interactions[layerKey][key] = interaction;
            }
        },
        setStatusAllMapInteractions(flag) {
            Object.keys(vars.interactions).forEach(layer => {
                Object.keys(vars.interactions[layer]).forEach(key => {
                    this.setStatusMapInteraction(layer, key, flag);
                });
            });
        },
        setStatusMapInteraction(layer, key, flag) {
            let interaction = vars.interactions[layer][key];
            if(interaction){
                if(!flag && interaction.getActive()){
                    interaction.setActive(false);
                }else if(flag && !interaction.getActive()){
                    interaction.setActive(true);
                }
            }
        },
        removeAllMapInteractions() {
            Object.keys(vars.interactions).forEach(layer => {
                Object.keys(vars.interactions[layer]).forEach(key => {
                    this.removeMapInteraction(layer, key);
                });
            });
        },
        removeMapInteraction(layer, key) {
            let interaction = vars.interactions[layer][key];
            if(interaction){
                interaction.setActive(false);
                let _map = interaction.getMap();
                if(_map) {
                    _map.removeInteraction(interaction);
                }
            }
            vars.interactions[layer][key] = null;
        },
        layerProperties(key) {
            return this.configMap.layers[key] ?? {};
        },
        styleProperties(key) {
            return this.configMap.style[key] ?? {};
        },
        getStyle(key) {
            const configStyle = this.styleProperties(key);
            let style = configStyle;
            if(!isArray(style)) {
                style = [style];
            }

            style = style.reduce((accumulator, item) => {
                let _res = JSON.parse(JSON.stringify(item));

                if(Object.hasOwn(_res, 'style')) {
                    _res.style = dotNotation(_res.style, {}, [], '-', true, true, true, '-');
                }else{
                    _res = dotNotation(_res, {}, [], '-', true, true, true, '-');
                }
                accumulator.push(_res);
                return accumulator;
            }, []);

            return style;
        },
        onSelectFeature(params={}) {
            const {map, layer, layerId, feature, geojson, zoom=false, callback = null} = params;
            let _mapClass = map ? map : vars?.map;
            let _map = _mapClass && _mapClass.getOLMap ? _mapClass.getOLMap() : _mapClass;

            if(zoom) {
                this.animateToFeature({
                    map: _map,
                    layer,
                    layerId,
                    feature,
                    geojson,
                    zoom,
                    callback: (complete, map, layer, feature, zoom) => {
                        let _layer = layer;
                        if(!layer && layerId) {
                            const _layerConfig = this.layerProperties(layerId);
                            _layer = _mapClass.getLayer(_layerConfig.layer);
                        }

                        this.flashFeature({
                            map,
                            layer: _layer,
                            feature,
                        });
                        if(isFunction(callback)) {
                            callback(complete, map, layer, feature, zoom)
                        }
                    },
                });
            }else{
                let _layer = layer;
                if(!layer && layerId) {
                    const _layerConfig = this.layerProperties(layerId);
                    _layer = _mapClass.getLayer(_layerConfig.layer);
                }

                this.flashFeature({
                    map: _map,
                    layer: _layer,
                    feature,
                    geojson
                });
            }
        },
        onDeSelectFeature(params={}) {
            const {map, ...rest} = params;
            let _mapClass = map ? map : vars?.map;
            let _map = _mapClass && _mapClass.getOLMap ? _mapClass.getOLMap() : _mapClass;

            this.resetFlashFeature({
                map: _map,
                ...rest
            });
        }
    },
    watch: {
        actionMap: {
            immediate: true,
            deep: true,
            handler(value, oldVal) {
                this.setStatusAllMapInteractions(!!!value);
            },
        },
    }
}